import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAssetsCountBooleanPipe'
})
export class FilterAssetsCountBooleanPipe implements PipeTransform {

  transform(items: any[], names: string, has_requested_amenities: boolean): any {
    if (!items) {
      return items.length == 0;
    }
    if(items && names == "" && has_requested_amenities) {
      return items.length == 0;
    }

    if(items && names == "" && has_requested_amenities) {
      return items.length == 0;
    }

    if(names != "") {
      if(has_requested_amenities) {
        return items.filter(
          item => (item.name.toLowerCase().indexOf(names.toLowerCase()) !== -1 ||
          item.wing_name.toLowerCase().indexOf(names.toLowerCase()) !== -1)
        ).length == 0;
      } else {
        return items.filter(
          item => item.has_requested_amenities == !has_requested_amenities &&
          (item.name.toLowerCase().indexOf(names.toLowerCase()) !== -1 ||
          item.wing_name.toLowerCase().indexOf(names.toLowerCase()) !== -1)
        ).length == 0;
      }
    } else {
      if(has_requested_amenities) {
        return items.length == 0;
      } else {
        return items.filter(
          item => item.has_requested_amenities == !has_requested_amenities
        ).length == 0;
      }
    }
  }
}
